var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"header"},[_c('SmallLoader')],1),_vm._v(" "),_c('div',{staticClass:"big-loader-wrapper"},[_c('InternalLoader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }